const EmptyColumnFilter = () => <td />;

export default EmptyColumnFilter;
